import axios from "axios";
import { axiosInstanceForLambda } from "./Axios";
import API_ENDPOINTS from "../apiEndpoints";
export const uploadToServer = (uploadedFile, fileName, fileType) => {
  return new Promise((resolve, reject) => {
    try {
      const filenameEncoded = encodeURIComponent(fileName)
      const fileTypeEncoded = encodeURIComponent(fileType);
      let data = "";
      let config = {
        method: "post",
        url: `${API_ENDPOINTS.REACT_APP_FILE_UPLOAD_URL}?filename=${filenameEncoded}&contentType=${fileTypeEncoded}`,
        // url: `https://xd8ts5u    b3e.execute-api.us-east-1.amazonaws.com/Prod/api/PreSigned/PreSignedUrl?filename=${uploadedFile.name}&contentType=${uploadedFile.type}`,
        headers: {},
        data: data,
      };
      // console.log('config', config);
      axiosInstanceForLambda(config)
        .then(function (response) {
          console.log("res :::: ", response.data);
          let config2 = {
            method: "put",
            url: response.data.signedUrl,
            headers: {
              "Content-Type": `${fileType}`,
            },
            data: uploadedFile,
          };
          console.log("config2", config2);
          axios(config2)
            .then(function (res) {
              resolve(res);
              console.log("res in upload :::: ", JSON.stringify(res.data));
            })
            .catch(function (error) {
              console.log("error in upload ::: ", error);
              reject();
            });
        })
        .catch(function (error) {
          console.log("errr ::: ", error);
          reject();
        });
    } catch (e) {
      console.log("error ::: ", e);
      reject();
    }
  });
};
